<template>
  <div :class="source == 1 ? 'bbs' : 'bbs mb-no'">
    <!-- <search></search> -->
    <!-- <div class="top">
      <div class="channels">
        <router-link :to="{name: 'BbsChannel', params: {id: c.id}}" v-for="c in channels" :key="'c_' + c.id">
          <img :src="c.logo_url" />
          <h3>{{ c.alias }}</h3>
        </router-link>
      </div>
    </div> -->
    <div class="content" style="margin-top: 0;">
      <van-tabs color="#F6AB00" title-active-color="#F6AB00" v-model="params.tname" @click="getName">
        <van-tab title="推荐" name=""></van-tab>
        <van-tab title="随手拍老车" name="随手拍老车"></van-tab>
        <van-tab title="晒爱车" name="晒爱车"></van-tab>
        <van-tab title="提问题" name="提问题"></van-tab>
        <van-tab title="改装" name="改装"></van-tab>
      </van-tabs>
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="this.img.loading" />
        <span>正在刷新</span>
      </div>
      <div class="list-box" v-for="(item, index) in list" :key="'list_' + item.id">
        <van-row type="flex" justify="space-between" v-if="item.user">
          <van-col span="4">
            <img class="listhand" :src="item.user.headimg_url ? item.user.headimg_url : img.avatar">
          </van-col>
          <van-col span="16">
            <div class="membername">
              {{item.user.user_name}}
            </div>
            <div class="sourtime">
              {{item.time_format}}  浏览 {{item.show_num}}
            </div>
          </van-col>
          <van-col class="bintright" span="4">
            <!-- <van-button plain round>+关注</van-button> -->
          </van-col>
        </van-row>
        <div class="listitle ellipsis-2" @click="BbsShow(item.id,item.url)">{{item.title}}</div>
        <div class="f-14 ellipsis-2" @click="BbsShow(item.id,item.url)"><span class="c-blue" v-if="item.tags.length>0">#{{item.tags[0].name}}#</span>
          {{item.content}}
        </div>
        <div class="text-r c-blue f-14" @click="BbsShow(item.id,item.url)">
         查看全部
       </div>
       <div class="pic-box" v-if="item.image.length<3&&item.image.length>0" @click="BbsShow(item.id,item.url)">
        <img class="pic_thumb" v-lazy="item.image[0]">
      </div>
      <div class="pic" v-if="item.image.length==3" @click="BbsShow(item.id,item.url)">

        <van-row gutter="5">
          <van-col span="16">
            <img v-if="item.image && item.image[0]" v-lazy="item.image[0]" />
          </van-col>
          <van-col span="8">
            <img v-if="item.image && item.image[1]" v-lazy="item.image[1]" class="right one" />
            <img v-if="item.image && item.image[2]" v-lazy="item.image[2]" class="right" />
          </van-col>
        </van-row>
      </div>
      <van-grid :border="false" :column-num="3" v-if="item.image.length>3" @click="BbsShow(item.id,item.url)">
        <van-grid-item v-for="(itemd, index) in item.image" :key="'img_' + index">
          <!-- <router-link :to="{name: 'BbsShow', params: {id: item.id}}" class="c-black"> -->
            <img class="nine-pic" v-lazy="itemd" />
            <!-- </router-link> -->
          </van-grid-item>
        </van-grid>
        <van-row type="flex" justify="space-between">
          <van-col span="14">
            <van-tag color="#F6AB00" round>{{item.channel.alias}}</van-tag>
          </van-col>
          <van-col class="bintright" span="10">
            <span class="">
              <img class="binpic" :src="img.comment">
              <span class="sourtime">{{item.comment_num}}</span>
            </span>
            <span class="binbox">
              <img class="binpic" @click="setPraise(index)" :src="item.is_praise ? img.parise_have : img.parise">
              <span class="sourtime">{{item.praise_num}}</span>
            </span>
          </van-col>
        </van-row>
      </div>
    </van-list>
  </div>
</div> 
</template>
<script>
  import bbs from '../../../api/bbs';
  import { mapState } from 'vuex';
  import {Grid, GridItem, List, Row, Col, Tab, Tabs, Tag, Button} from "vant";
  import Search from '../Common/Search';

  export default {
    data () {
      return {
        params: {
          page: 1,
          size: 4,
          user_id: 0,
          tname: '',
          is_lexus_app: 1
        },
        channels: [],
        list: [],
        loading: false,
        finished: false,
        img: {
          avatar: require('../../../assets/img/default.jpg'),
          parise: require('../../../assets/img/parise.png'),
          parise_have: require('../../../assets/img/parise_have.png'),
          comment: require('../../../assets/img/comment.png'),
          loading: require('../../../assets/img/loading.gif')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.getChannels()
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    activated () {
      if(this.source == 1) {
        this.$store.commit('param/show', true)
        this.$store.commit('param/active', 'Bbs')
      } else {
        this.$store.commit('param/show', false)
        this.$appService.isShowReturn({state: false})
      }
    },
    methods: {
      BbsShow(id,url){
        this.$router.push({name:'BbsShow',params:{id:id}});
        // if(url){
        //   var strs = new Array(); //定义数组 
        //   strs = url.split("https://h5.motortime.com/lexus/");
        //   var strsurl = strs[1]
        //   var strslist = []
        //   strslist = strsurl.split("/");
        //   if (strslist[1] && strslist[0] == "article") {
        //     this.$router.push({name:'ContentPostShow',params:{id:strslist[1]}});
        //   }
        // }else{
        //   this.$router.push({name:'BbsShow',params:{id:id}});
        // }
        
      },
      setPraise (index) {
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
                url:'',
                pagetype:0
              }
              this.$appService.needLogin(params)
            }
          })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }

        if(this.user) {
          let type = this.list[index].is_praise ? 2 : 1;
          bbs.setPraise({id: this.list[index].id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.list[index].is_praise = 1
                this.list[index].praise_num += 1
                this.$toast.success('点赞成功')
              } else {
                this.list[index].is_praise = 0
                this.list[index].praise_num -= 1
                this.$toast.success('取消成功')
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }
      },
      getName() {
        this.params.page = 1;
        this.list = [];
        this.onLoad();
      },
      getChannels() {
        bbs.getChannels().then(res => {
          if(res.data.state == 1) {
            this.channels = res.data.data
          }
        })
      },
      onLoad() {
        this.params.user_id = this.user ? this.user.id : 0
        this.params.is_lexus_app = this.params.tname ? 0 : 1
        // 异步更新数据
        setTimeout(() => {
          bbs.getList(this.params).then(res => {
            this.list.push.apply(this.list, res.data.data.data)
            this.params.page += 1
            this.loading = false

            if(res.data.data.data.length == 0) {
              this.finished = true
            }
          })
        }, 500);
      }
    },
    components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Row.name]: Row,
      [Col.name]: Col,
      [List.name]: List,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Tag.name]: Tag,
      [Button.name]: Button,
      // Search
    }
  };
</script> 

<style lang="scss">
.bbs {
  // margin: 60px 0;
  background-color: #F0F0F0;

  .top {
    background-color: #FFF;
    padding: 10px;

    .channels {
      width: 100%;
      overflow-x:scroll;
      overflow-y: hidden;
      display: flex;

      &::-webkit-scrollbar {
        display:none;
      }
      a {
        display: inline-block;
        margin-right: 5px;

        img {
          width: 73px;
          height: 73px;
          border-radius: 2px;
          margin: 0 6px;
          display: block;
        }
        h3 {
          color: #3A3A3A;
          font-size: 12px;
          text-align: center;
          margin: 5px 0;
        }
      }
    }
  }
  .content {
    background-color: #FFF;
    /*margin-top: 10px;*/

    .van-tab span {
      font-size: 13px;
    }
    .list-box {
      padding: 15px 10px;
      border-bottom: 1px solid #EAEAEA;

      .listitle{
        font-size: 16px;
        font-weight:bold;
        line-height: 32px;
        letter-spacing: 1.4px;
      }
      .sourtime{
        font-size: 12px;
        color: #9A9A9A;
      }
      .bintright{
        text-align:right;
        .binbox{
          margin-left:20px;
        }
        .binpic{
          width:15px;
          height:14px;
          margin-right:8px;
          // vertical-align: middle;
        }
        .van-button--default {
          color: #F6AB00;
          border: 1px solid #F6AB00;
          width: 60px;
          height: 25px;
          line-height: 25px;
          font-size: 12px;
          padding: 0;
        }
      }
      .pic-box {
        padding: 10px 0;
        .pic_thumb {
          border-radius: 5px;
          width: 100%;
          height: 225px;
          object-fit: cover;
          display: block;
        }
      }
      .pic {
        img {
          width: 100%;
          height: 205px;
          object-fit: cover;
          display: block;
          border-radius: 3px;

          &.right {
            height: 100px;
          }
          &.one {
            margin-bottom: 5px;
          }
        }
      }
      .nine-pic {
        width: 100%;
        height: 100px;
        border-radius: 3px;
        object-fit: cover;
        display: block;
      }
      .listhand{
        width:45px;
        height:45px;
        border-radius:30px;
      }
      .membername{
        font-size: 15px;
        font-weight: bold;
      }
      .van-tag{
        padding: 0 5px;
      }
      .quespic{
        width: 22px;
        height: 22px;
      }
      .van-grid-item__content{
        padding: 2.5px;
      }

    }
  }
}
</style>
